<div>
  <!-- BANNER IMG -->
  <div>
    <slot name="banner_image"></slot>
  </div>

  <!-- REGION SELECT -->
  @if (form) {
    <form [formGroup]="form">
      <div class="positioning-container">
        <!-- CONTROL -->
        <mat-form-field appearance="outline">
          <mat-label>Select Region</mat-label>
          <mat-select aria-label="Select Region" formControlName="region" [placeholder]="'Select Region'">
            @for (region of regions; track trackByIndex($index, region)) {
              <mat-option [value]="region.value">
                {{region.label}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <br />
        <!-- BUTTONS CONTAINER -->
        @if (regionSelected) {
          <div class="buttons-container">
            <!-- DOCTOR BUTTON -->
            <button type="button" mat-button color="info" (click)="navigateToFindADoctor()">
              <div class="icon-container">
                <!-- SERVICES IMAGES -->
                <div>
                  <slot name="services_image_1"></slot>
                </div>
                <!-- TEXT -->
                <div>
                  <slot name="text_one"></slot>
                </div>
              </div>
            </button>
            <!-- PHARMACY BUTTON -->
            <button type="button" mat-button color="info"  (click)="navigateToFindPharmacy()">
              <div class="icon-container">
                <!-- SERVICES IMAGES -->
                <div>
                  <slot name="services_image_2"></slot>
                </div>
                <!-- TEXT -->
                <div>
                  <slot name="text_two"></slot>
                </div>
              </div>
            </button>
          </div>
        }
      </div>
    </form>
  }
</div>